module.exports = __webpack_public_path__ + "static/media/b6-上海市鹤龙美术馆.adc826e9.png";